// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation_menuItems__17YwH {\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  border-radius: 8px;\n  background-color: var(--primary-dark);\n  list-style-type: none;\n}\n.navigation_menuItems__17YwH a {\n  margin: 4px;\n  text-transform: uppercase;\n  border-radius: 5px;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n.navigation_menuItems__17YwH a:hover {\n  color: var(--text-primary);\n  background-color: var(--primary);\n}\n.navigation_menuItems__17YwH a.navigation_active__1X8E0 {\n  background-color: var(--orange);\n}", ""]);
// Exports
exports.locals = {
	"menuItems": "navigation_menuItems__17YwH",
	"active": "navigation_active__1X8E0"
};
module.exports = exports;
